import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/mock";

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-16 lg:py-24 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="max-w-2xl mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 text-xs font-semibold text-orange-600 mb-4">
            <span className="w-1.5 h-1.5 bg-orange-500 rounded-full" />
            REAL REVIEWS
          </div>
          <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.025em] text-stone-900">
            Loved by the homes
            <br />
            <span className="text-stone-500">— inside & out.</span>
          </h2>
        </div>

        {/* Reviews grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={`${t.project}-${i}`}
              data-testid={`testimonial-${i}`}
              className="bg-stone-50 rounded-3xl p-8 lg:p-10 flex flex-col hover:bg-white hover:border-stone-900/20 hover:shadow-[0_24px_50px_-20px_rgba(28,25,23,0.18)] border border-stone-200 transition-all duration-500"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-0.5">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <Star key={s} size={16} className="fill-orange-500 text-orange-500" />
                  ))}
                </div>
                <Quote size={28} strokeWidth={1.5} className="text-stone-300" />
              </div>
              <blockquote className="text-[17px] leading-[1.55] text-stone-800 flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-stone-200">
                <div className="font-semibold text-stone-900">{t.name}</div>
                <div className="mt-1 text-xs uppercase tracking-wider text-orange-600 font-medium">
                  {t.project}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
